'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Sentry = require('@sentry/browser');
var createSentryMiddleware = require('redux-sentry-middleware');
var masked = require('./masked.js');
var _get = require('lodash/get');
var _set = require('lodash/set');
var sensitiveKeys = require('./sensitive-keys.js');
require('@babel/runtime/helpers/defineProperty');
require('lodash/repeat');
require('lodash/forOwn');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var Sentry__namespace = /*#__PURE__*/_interopNamespace(Sentry);
var createSentryMiddleware__default = /*#__PURE__*/_interopDefaultLegacy(createSentryMiddleware);
var _get__default = /*#__PURE__*/_interopDefaultLegacy(_get);
var _set__default = /*#__PURE__*/_interopDefaultLegacy(_set);

var ERROR_CODES = {
  INVALID_AUTHENTICATION: 10007
};
var ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network Error'
};
var STATUS_CODES = {
  UNAUTHORIZED: 401,
  SERVER_ERROR: 500
}; // @ts-expect-error TS(7006): Parameter 'error' implicitly has an 'any' type.

var _ignore = function _ignore(error) {
  return process.env.NODE_ENV === 'test' || error.message === ERROR_MESSAGES.NETWORK_ERROR || _get__default["default"](error, 'data.statusCode') === STATUS_CODES.UNAUTHORIZED || _get__default["default"](error, 'data.statusCode') >= STATUS_CODES.SERVER_ERROR || _get__default["default"](error, 'data.errorCode') === ERROR_CODES.INVALID_AUTHENTICATION;
}; // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.


var clearUserContext = function clearUserContext() {
  return Sentry__namespace.setUser();
};
var createReduxMiddleware = function createReduxMiddleware() {
  return createSentryMiddleware__default["default"](Sentry__namespace, {
    // @ts-expect-error TS(7006): Parameter 'action' implicitly has an 'any' type.
    actionTransformer: function actionTransformer(action) {
      return masked["default"](action, sensitiveKeys["default"]);
    },
    // @ts-expect-error TS(7006): Parameter 'state' implicitly has an 'any' type.
    stateTransformer: function stateTransformer(state) {
      return masked["default"](state, sensitiveKeys["default"]);
    }
  });
};
var logError = function logError( // @ts-expect-error TS(7006): Parameter '_error' implicitly has an 'any' type.
_error, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      name = _ref.name,
      data = _ref.data;

  var error = _error;

  if (error instanceof Error) {
    var _error2, _error2$config;

    // @ts-expect-error TS(2339): Property 'config' does not exist on type 'Error'.
    var errorHeaders = (_error2 = error) == null ? void 0 : (_error2$config = _error2.config) == null ? void 0 : _error2$config.headers;
    var maskedErrorHeaders = masked["default"](errorHeaders, ['Authorization']);
    error = _set__default["default"](error, 'config.headers', maskedErrorHeaders);

    try {
      var _error3, _error3$config;

      var errorData = (_error3 = error) == null ? void 0 : (_error3$config = _error3.config) == null ? void 0 : _error3$config.data;
      var maskedErrorData = masked["default"](JSON.parse(errorData), sensitiveKeys["default"]);
      error = _set__default["default"](error, 'config.data', JSON.stringify(maskedErrorData));
    } catch (err) {}
  }

  if (_ignore(error)) {
    return null;
  }

  Sentry__namespace.withScope(function (scope) {
    scope.setExtra('error', error);
    scope.setExtra('data', masked["default"](data, sensitiveKeys["default"]));

    var message = _get__default["default"](error, 'data.message', error.message);

    var sentryError = error instanceof Error ? error : new Error(message);

    if (name) {
      sentryError.name = name || message;
    }

    Sentry__namespace.captureException(sentryError);
  });
  console.error(error);
}; // @ts-expect-error TS(7031): Binding element 'environment' implicitly has an 'a... Remove this comment to see the full error message

var setup = function setup(_ref2) {
  var environment = _ref2.environment,
      url = _ref2.url,
      version = _ref2.version;

  if (window.location.hostname !== 'localhost') {
    Sentry__namespace.init({
      dsn: url,
      environment: environment,
      release: version
    });
  }
}; // @ts-expect-error TS(7006): Parameter 'user' implicitly has an 'any' type.

var setUserContext = function setUserContext(user) {
  return Sentry__namespace.setUser(masked["default"](user, sensitiveKeys["default"]));
}; // @ts-expect-error TS(7006): Parameter 'key' implicitly has an 'any' type.

var setTag = function setTag(key, value) {
  return Sentry__namespace.setTag(key, value);
};
var sentry = {};

exports.clearUserContext = clearUserContext;
exports.createReduxMiddleware = createReduxMiddleware;
exports["default"] = sentry;
exports.logError = logError;
exports.setTag = setTag;
exports.setUserContext = setUserContext;
exports.setup = setup;
